import { EsrsReportMetric } from '../../Report.types';
import { S1_6CountryMetrics, S1_6GenderMetrics } from '../../ReportComponents';
import { createMetrics } from '../Functions/metrics';
import { addEmptySpace, createCustomMetricTable } from '../report-helper-functions';
import { createS16GenderTable, createS16CountryTable } from './employees-by-contract';

export const createS16Tables = (metrics: EsrsReportMetric[], companyCurrency: string) => {
  const employeesGender = metrics?.find((m) => m.metric.metricRef === 'employeesGender')?.tableData;
  const employeesCountry = metrics?.find(
    (m) => m.metric.metricRef === 'employeesCountry'
  )?.tableData;

  const totalEmployees = metrics.find((m) => m.metric.metricRef === 'totalEmployees');

  const s16GenderTableMetrics = metrics
    .filter((m) => S1_6GenderMetrics.includes(m.metric.metricRef))
    .map((m) => m.tableData);
  const s16CountryTableMetrics = metrics
    .filter((m) => S1_6CountryMetrics.includes(m.metric.metricRef))
    .map((m) => m.tableData);

  const ref50bMetrics = s16GenderTableMetrics.find(
    (metric) => metric.metric.reference === 'totalEmployeesByContractGender'
  );

  const ref51Metrics = s16CountryTableMetrics.find(
    (metric) => metric.metric.reference === 'totalEmployeesContractGenderAndCountry'
  );

  if (!ref50bMetrics && ref51Metrics) {
    s16GenderTableMetrics.push(ref51Metrics);
  }

  let totalEmployeeByContactGender = metrics.find(
    (m) => m.metric.metricRef === 'totalEmployeesByContractGender'
  )?.tableData;

  if (!totalEmployeeByContactGender) {
    totalEmployeeByContactGender = metrics.find(
      (m) => m.metric.metricRef === 'totalEmployeesContractGenderAndCountry'
    )?.tableData;
  }

  return [
    employeesGender
      ? [
          createCustomMetricTable(
            employeesGender,
            [
              { header: 'Gender', key: 'title' },
              { header: 'Number of employees (head count)', key: 'result' },
            ],
            companyCurrency
          ),
          addEmptySpace(300),
        ]
      : [],
    employeesCountry
      ? [
          createCustomMetricTable(
            employeesCountry,
            [
              { header: 'Country', key: 'title' },
              { header: 'Number of employees (head count)', key: 'result' },
            ],
            companyCurrency,
            true
          ),
        ]
      : [],
    totalEmployees ? createMetrics([totalEmployees], companyCurrency) : [],
    createS16GenderTable(s16GenderTableMetrics, totalEmployeeByContactGender),
    createS16CountryTable(s16CountryTableMetrics),
  ].flat();
};
